import React from 'react';
import { useStateContext } from '../../../../context/ContextProvider';
import ColorLandingPage from '../../../LandingPages/ColorLandingPage';

function NinaAziziMilan({
    language
}) {
    const images = [
        "/assets/images/projects/azizi-milan/1.webp",
        "/assets/images/projects/azizi-milan/2.webp",
        "/assets/images/projects/azizi-milan/3.webp",
        "/assets/images/projects/azizi-milan/4.webp"
    ];

    const poster = "/assets/images/projects/azizi-milan/poster.jpg";
    // const webm = "/assets/images/projects/azizi-milan/hero.webm";
    const video = "/assets/images/projects/azizi-milan/azizi-milan.mp4";

    const {
        langs,
        langCode,
        userInfo,
        FINDESTATES_URL,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName == "United Arab Emirates";
    const isIraq = userInfo?.countryName == "Iraq";
    const isIran = userInfo?.countryName == "Iran";
    const isTurkey = userInfo?.countryName == "Turkey";
    const isUSA = userInfo?.countryName == "United States";
    const isCanada = userInfo?.countryName == "Canada";

    const Heading = () => {
        return (
            <>
                {language == "ar" ? (
                    <h1 className="text-center text-xl lg:text-2xl font-bold">
                        <span className="primary-text">
                            الوحدات محدودة ..
                        </span>
                        &nbsp;
                        سجل بياناتك الأن
                    </h1>
                ) : (
                    <h1 className="font-bold text-center text-xl">
                        Your opportunity to own property in the heart of Dubai
                        <br />
                        with installments of
                        <span className="text-2xl primary-text">AED 5800</span>
                        only
                        <br />
                        Register your details and we will send you the information
                    </h1>
                )}

            </>
        );
    }

    const gridDetails = [
        {
            "topic": "أنواع الوحدات",
            "text": "استوديو 3,2,1 غرفة",
        },
        {
            "topic": "الأسعار تبدأ من",
            "text": isUAE ? "590,000 درهم" : "160 ألف دولار",
        },
        {
            "topic": "أقساط شهرية",
            "text": isUAE ? "5900 درهم" : "1600 دولار",
        },
    ];

    const imageDetails = {
        "title": "✨ عرض حصري لفترة محدودة ✨",
        "desc": "احجز وحدتك الآن واستمتع بمطبخ مجهز بالكامل بجميع الأجهزة الكهربائية من ماركة Siemens الألمانية"
    };

    return (
        <>
            {/* LANGUAGE */}
            {/* <LanguageNavigate
                    support={["en", "ar", "fa", "tr"]}
                    redirect={{
                        en: "/projects/azizi/milan",
                        ar: "/projects/azizi/milan/ar",
                        fa: "/projects/azizi/milan/fa",
                        tr: "/projects/azizi/milan/tr",
                    }}
                /> */}
            <ColorLandingPage
                color="gold"
                // language={language}
                poster={poster}
                video={video}
                images={images}
                heading={<Heading />}
                gridDetails={gridDetails}
                imageDetails={imageDetails}
                projectName={""}
                base_url={FINDESTATES_URL}
                developer="Azizi"
                project="Milan"
                leadType="Apartment"
                language={language === "ar" ? "Arabic" : language === "fa" ? "Farsi" : language === "tr" ? "Turkish" : "English"}
                enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms"]}
                contactTime={isUSA || isCanada ? true : false}
                otpCode={6}
            />
        </>
    );
}

export default NinaAziziMilan;
